// axios 发送ajax请求
import request from '@/utils/request'

export default {
  // Native下单
  nativePay(productId, account, count) {
    return request({
      url: '/public/api/wx-pay/native/' + productId + '/' + account + '/' + count,
      method: 'post'
    })
  },

  cancel(orderNo) {
    return request({
      url: '/public/api/wx-pay/cancel/' + orderNo,
      method: 'post'
    })
  },

  refunds(orderNo, reason) {
    return request({
      url: '/public/api/wx-pay/refunds/' + orderNo + '/' + reason,
      method: 'post'
    })
  },
  nativePay1(productId, account, count) {
    return request({
      url: '/public/api/wx-pay/native1/' + productId + '/' + account + '/' + count,
      method: 'post'
    })
  },

  cancel1(orderNo) {
    return request({
      url: '/public/api/wx-pay/cancel1/' + orderNo,
      method: 'post'
    })
  },

  refunds1(orderNo, reason) {
    return request({
      url: '/public/api/wx-pay/refunds1/' + orderNo + '/' + reason,
      method: 'post'
    })
  }
}
